import { Trans } from '@lingui/react'
import { type SellerPromotionV1 } from '@redteclab/api/clients/bully'
import { type FC } from 'react'

import {
  currencyToSymbol,
  formatPriceString,
} from 'views/components/atoms/Price/helpers'
import Notification from 'views/components/molecules/Notification'
import useMountPoints from 'views/enhancers/useMountPoints'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

export type SellerPromotionBannerProps = {
  promotion: SellerPromotionV1
  sellerId: string
}

const getFormattedDiscountAmount = (
  sellerPromotion: SellerPromotionV1,
  locale: string,
  currency: string,
  currencySymbolRight: boolean
) => {
  switch (sellerPromotion.discountType) {
    case 'totalAmount':
      return formatPriceString({
        currencySymbol: currencyToSymbol(currency),
        amount: sellerPromotion.discountValue,
        symbolRight: currencySymbolRight,
        locale,
      })
    case 'totalPercent':
      return `${sellerPromotion.discountValue * 100}%`
    default:
      return ''
  }
}

const getFormattedMovAmount = (sellerPromotion: SellerPromotionV1) =>
  sellerPromotion.minimumOrderValue + '€'

export const SellerPromotionBanner: FC<SellerPromotionBannerProps> = ({
  promotion,
  sellerId,
}) => {
  const mountPoints = useMountPoints()
  const { currency, locale, currencySymbolRight } = usePublicConfig()

  return (
    <div
      className="u-margin--bottom u-border o-Cart-ErxNotification--Border"
      data-qa-id="show-erx-bonus-notUsed"
    >
      <Notification
        alignIcon="top"
        className="u-background-color--background"
        dataQaId={`seller-not-applied-promotion-banner-${sellerId}`}
        heading={
          <Trans
            id="seller.promotion.sellerBanner.title"
            values={{
              formattedDiscountAmount: getFormattedDiscountAmount(
                promotion,
                locale,
                currency,
                currencySymbolRight
              ),
            }}
          />
        }
        label={
          <div>
            <div
              className="u-margin-x-small--bottom"
              data-qa-id={`seller-not-applied-promotion-banner-message-${sellerId}`}
            >
              <Trans
                id="seller.promotion.sellerBanner.message"
                values={{
                  formattedMovAmount: getFormattedMovAmount(promotion),
                }}
              />
            </div>
            <a
              href={mountPoints.getSellerProducts(sellerId)}
              className="o-Cart-Notification-link"
              data-qa-id={`seller-not-applied-promotion-banner-serp-link-${sellerId}`}
            >
              <Trans id="seller.promotion.product.banner.sellerSerpLink" />
            </a>
          </div>
        }
        type="infoNoBgColor"
      />
    </div>
  )
}
